import * as React from 'react'
import { Button } from 'antd'

interface IViewExpenseCommentsButtonProps {
    onChange: () => void;
}

export const ViewExpenseCommentsButton: React.FC<IViewExpenseCommentsButtonProps> = ({ onChange }) => {
    return (
        <Button
            onClick={onChange}
            style={{ margin: "auto 20px 20px auto", display: "inline-block" }}
        >
            Ver Lista de Atualizações
        </Button>
    );
}


// WEBPACK FOOTER //
// ./src/components/common/ExpenseComments/Buttons/ViewExpenseCommentsButton/ViewExpenseCommentsButton.tsx